import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import styles from './style.css';
import { Link } from "react-router-dom";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import UQFormErrors from "../../../../uq-forms/components/form-errors";
import UQFormsTextField from "../../../../uq-forms/components/text-field";
import UQFormsPasswordField from "../../../../uq-forms/components/password-field";
import UQButton from "../../../../uq-ui/components/button";
import { 
  registerByEmail, 
  setEmail, 
  setFormErrors, 
  setPassword, 
  setConfirmPassword 
} from "../../../store/register-by-email/actions";
import {
  registerByEmailFormErrorsSelector,
  registerByEmailPasswordSelector,
  registerByEmailConfirmPasswordSelector,
  registerByEmailSelector
} from "../../../store/register-by-email/selectors";
import { RegisterEmailErrorCodeEnum } from "../../../domain/enums/RegisterEmailErrorEnum";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import { currentUserInfoSelector } from "../../../store/auth-user/selectors";
import Div100vh from "../../../../uq-ui/components/div-100";
import { createErrorExtractor } from "../../../../uq-forms/helpers";

const GreetingImage = require('./greeting.svg');

const errorExtractor = createErrorExtractor({
  email: {
    [RegisterEmailErrorCodeEnum.InvalidEmail]: 'errors.invalidEmail',
    [RegisterEmailErrorCodeEnum.EmailAlreadyInUse]: 'errors.emailAlreadyInUse'
  },
  password: {
    [RegisterEmailErrorCodeEnum.WeakPassword]: 'errors.weakPassword',
  },
  confirmPassword: {
    [RegisterEmailErrorCodeEnum.PasswordsNotMatch]: 'errors.passwordsNotMatch',
  },
  form: {
    [RegisterEmailErrorCodeEnum.OperationNotAllowed]: 'errors.unknownError',
  }
});

class AuthScreensRegistration extends PureComponent {

  componentDidMount() {
    this.props.resetFormErrors();
  }

  onBack = () => {
    this.props.history.replace('/login');
  };

  render() {
    const registerBtnStyle = document.body.clientHeight < 550 ? { marginTop: '3vh' } : {};
    return (
      <Div100vh className={styles.container}>
        <LayoutComponentsHeader showBackBtn={true} 
                                onBack={this.onBack}
                                showLogo={true} />
        <div className={styles.innerTop}>
          <div className={`${styles.authTogglerLinkActive} font-title`}>{this.props.t('registration')}</div>
          <div className={styles.formContainer}>
            <div className={styles.form}>
              { this.props.formErrors.form && (
                <UQFormErrors
                  textStyle={{ textAlign: 'center' }}
                  error={errorExtractor.get('form', this.props.formErrors, this.props.t)} />
              ) }
              <UQFormsTextField
                label={this.props.t('email')}
                type="email"
                labelClassName="font-text"
                autoCapitalize="none"
                value={this.props.email}
                error={errorExtractor.get('email', this.props.formErrors, this.props.t)}
                onChange={(event) => this.props.onChangeEmail(event.target.value)}
              />
              <UQFormsPasswordField
                label={this.props.t('password')}
                labelClassName="font-text"
                autoCapitalize="none"
                value={this.props.password}
                error={errorExtractor.get('password', this.props.formErrors, this.props.t)}
                onChange={(event) => this.props.onChangePassword(event.target.value)}
              />
              <UQFormsPasswordField
                label={this.props.t('confirmPassword')}
                autoCapitalize="none"
                labelClassName="font-text"
                eyeVisible={false}
                value={this.props.confirmPassword}
                error={errorExtractor.get('confirmPassword', this.props.formErrors, this.props.t)}
                onChange={(event) => this.props.onChangeConfirmPassword(event.target.value)}
              />
            </div>
          </div>
          <UQButton label={this.props.t('registerBtn')}
                    containerClass={styles.submitBtnWrap}
                    onPress={this.props.registerByEmail}
                    containerStyle={registerBtnStyle}/>
        </div>
        <div className={styles.innerBottom}>
          <img src={GreetingImage} className={styles.greeting} />
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: registerByEmailSelector(state),
    password: registerByEmailPasswordSelector(state),
    confirmPassword: registerByEmailConfirmPasswordSelector(state),
    formErrors: registerByEmailFormErrorsSelector(state),
    currentUserInfo: currentUserInfoSelector(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangePassword: (value) => dispatch(setPassword(value)),
    onChangeConfirmPassword: (value) => dispatch(setConfirmPassword(value)),
    onChangeEmail: (value) => dispatch(setEmail(value)),
    resetFormErrors: () => dispatch(setFormErrors({})),
    registerByEmail: () => dispatch(registerByEmail())
  }
};

export default compose(
  withTranslation('scr-registration'),
  connect(mapStateToProps, mapDispatchToProps)
)(AuthScreensRegistration);